var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.36,
    height: 22,
    viewBox: "0 0 19.36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-chat-bot-5233328",
    transform: "translate(-92.54 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48184",
    "data-name": "Path 48184",
    d: "M133.912,24.018a8.806,8.806,0,0,0-7.874-5.611V16.6a1.32,1.32,0,1,0-.658,0v1.811a8.8,8.8,0,0,0-7.874,5.611,4.169,4.169,0,0,0,0,6.364,8.8,8.8,0,0,0,16.41,0,4.169,4.169,0,0,0,0-6.364Zm-2.7,6.7h-11a3.52,3.52,0,1,1,0-7.04h11a3.52,3.52,0,0,1,0,7.04Zm-.22-3.52a1.32,1.32,0,1,1-1.32-1.32A1.319,1.319,0,0,1,130.987,27.2Zm-7.92,0a1.32,1.32,0,1,1-1.32-1.32A1.319,1.319,0,0,1,123.067,27.2Z",
    transform: "translate(-23.492)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLogo);
export default __webpack_public_path__ + "static/media/chat-logo.1fcf6210dc8219eb2902fc6c4be7409c.svg";
export { ForwardRef as ReactComponent };